interface TableUpdateParams {
  time?: number;
  reverse?: boolean;
  type?: string;
  view?: string;
  include?: string[];
  exclude?: string[];
}

function setDefined(url: URLSearchParams, record: TableUpdateParams): void {
  for (const [key, value] of Object.entries(record)) {
    if (value === undefined) {
      continue;
    }

    const v = String(value);
    if (v === '') {
      url.delete(key);
    } else {
      url.set(key, String(value));
    }
  }
}

export function makeRelativeLogLink(
  params: TableQueryOpts,
  update: TableUpdateParams,
  unset?: (keyof TableUpdateParams)[],
): string {
  // CAST: Values are stringified.
  const search = new URLSearchParams();
  setDefined(search, params);
  setDefined(search, update);
  if (unset) {
    for (const key of unset) {
      search.delete(key);
    }
  }

  return `${location.pathname}?${search.toString()}`;
}

export interface TableQueryOpts {
  highlight?: string;
  view?: string;
  time?: number;
  reverse: boolean;
  offset?: number;
  type?: string;
  include: string[];
  exclude: string[];
}

export function urlSearchParamsToTableOpts(params: URLSearchParams): TableQueryOpts {
  return {
    highlight: params.get('highlight') ?? undefined,
    type: params.get('type') ?? undefined,
    offset: params.has('offset') ? Number.parseInt(params.get('offset')!, 10) : undefined,
    reverse: params.get('reverse') === 'true',
    time: params.has('time') ? Number.parseInt(params.get('time')!, 10) : undefined,
    view: params.get('view') ?? undefined,
    include: params.get('include')?.split(',') ?? [],
    exclude: params.get('exclude')?.split(',') ?? [],
  };
}
